<template>
  <div class="disabled">
    <div class="row">
      <div class="col-4 col-md-4 col-lg-3">
        <div id="sidebar-wrapper">
          <Sidebar :routes="routes" />
        </div>
      </div>
      <div class="col-8 col-md-8 col-lg-9">
        <Index />
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from "@/views/Layouts/Sidebar";
import Index from "@/components/DisabledItems/Index";

export default {
  name: "disabled",
  components: { Sidebar, Index },
  data() {
    return {
      routes: [
        {
          link: "/items",
          title: "Items"
        },
        {
          link: "/categories",
          title: "Categories"
        },
        {
          link: "/disabled-items",
          title: "Disabled Items"
        }
        // ,{
        //   link: "/discounts",
        //   title: "Discounts"
        // }
      ]
    };
  }
};
</script>
